<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <!--<div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-facture">
          <i class="fa fa-plus-circle"></i>
          Ajouter facture
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15">
          <input type="text" name="mot" v-model="searchTerm"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une facture" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>-->
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-facture">
          <i class="fa fa-plus-circle"></i>
          Ajouter facture
        </router-link>
      </div>
      <div class="d-flex align-items-center" v-if="(lesFactureAImprimer && lesFactureAImprimer.length <= 0)">
        <button type="button" @click="getPoint()" v-if="valideEtape3"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          Exporter
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
      <div class="d-flex align-items-center" v-if="(lesFactureAImprimer && lesFactureAImprimer.length > 0)">
        <button type="button" @click="imprimer()" v-if="valideEtape3"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none">
          <i class="flaticon-download position-relative ms-5 fs-12"></i>
          Télécharger
        </button>
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-secondary fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0 text-decoration-none"
          type="button" v-if="!valideEtape3" disabled>
          <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
          <span class="visually-hidden">Chargement...</span>
        </button>
      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mot clé
              </label>
              <Field v-model="motCle" name="mot" type="text" aria-disabled="true"
                class="form-control shadow-none fs-md-15 text-black" placeholder="Recherche par mot clé" />
              <ErrorMessage name="mot" class="text-danger" />
            </div>
          </div>
          <div class="col-md">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Marché
              </label>
              <Field v-model="marche" name="marche" v-slot="{ field }">
                <Multiselect v-model="field.value" v-bind="field" placeholder="Sélectionner le contrat"
                  contratholder="Rechercher une marché" :filter-results="true" :searchable="true"
                  :options="marcheOptions" noResultText="Aucun enregistrement trouvé"
                  noOptionsText="Tapez au moins trois caractères" />
              </Field>
              <ErrorMessage name="marche" class="text-danger" />
            </div>
          </div>
          <div class="col-md col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Statut
              </label>
              <Field name="statut" v-model="_statut" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 0, label: 'Impayée' },
                  { value: 1, label: 'En attente ' },
                  { value: 2, label: 'Normalisée' },
                  { value: 3, label: 'Annulée' },
                  { value: 4, label: 'Normalisée & Payée' },
                  { value: 5, label: 'Avoir' }
                ]" v-model="field.value" v-bind="field" placeholder="Sélectionner le statut" />
              </Field>
            </div>
          </div>

          <div class="col-md">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Type
              </label>
              <Field v-model="_type" name="type" v-slot="{ field }">
                <Multiselect 
                  v-model="field.value" 
                  v-bind="field" 
                  :options="typesOptions" 
                  :preserve-search="true"
                  :multiple="false" 
                  :searchable="true" placeholder="Sélectionner le type" label="label"
                  track-by="label" />
              </Field>
              <ErrorMessage name="type" class="text-danger" />
            </div>
          </div>
          
          <div class="col-md col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Mois
              </label>
              <Field name="mois" v-model="_mois" type="text" v-slot="{ field }">
                <Multiselect :searchable="true" :options="[
                  { value: 0, label: 'Janvier' },
                  { value: 1, label: 'Février' },
                  { value: 2, label: 'Mars' },
                  { value: 3, label: 'Avril' },
                  { value: 4, label: 'Mai' },
                  { value: 5, label: 'Juin' },
                  { value: 6, label: 'Juillet' },
                  { value: 7, label: 'Août' },
                  { value: 8, label: 'Septembre' },
                  { value: 9, label: 'Octobre' },
                  { value: 10, label: 'Novembre' },
                  { value: 11, label: 'Décembre' },
                ]" v-model="field.value" v-bind="field" placeholder="Sélectionner le mois" />
              </Field>
            </div>
          </div>

          <div class="col-md col-xm-12 col-sm-12">
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <label class="d-block text-black fw-semibold mb-10">
                Année
              </label>
              <Field name="annee" v-model="_annee" type="text" v-slot="{ field }">
                <Multiselect :options="_annees" :searchable="true" v-model="field.value" v-bind="field"
                  placeholder="Sélectionner une année" />
              </Field>
              <ErrorMessage name="annee" class="text-danger" />
            </div>
          </div>
        </div>


      </div>
    </div>
    <hr/>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th>
                <div class="form-check">
                  <Field name="checking" type="checkbox" value="Tout sélectionner" id="Tout sélectionner"
                    @change="toggleAllCheckboxes($event)" class="form-check-input"
                    :checked="factures && factures.length > 0 && checkedFactures.length === factures.length" />
                </div>

              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Reference
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Nom du marchand
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code de la place
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Date
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Montant
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Mois
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Contrat
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(facture, index) in factures" :key="index">
              <td>
                <div class="form-check">
                  <Field name="checking" type="checkbox" @change="ajouterTableau($event, facture.id)" :value="facture.id"
                    :id="facture.id" class="form-check-input" v-model="checkedFactures" />
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture.reference }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture?.nomMarchand }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture?.codePlace }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture.date_facture }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ facture.montant_facture }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis text-center">
                <span class="badge bg-danger text-white" v-if="facture?.natureFacture == 0">
                  Loyer
                </span>
                <span class="badge bg-info text-white" v-if="facture?.natureFacture == 1">
                  Caution
                </span>
                <span class="badge bg-success text-white" v-if="facture?.natureFacture == 2">
                  Electricité
                </span>
                <span class="badge bg-primary text-white" v-if="facture?.natureFacture == 3">
                  Loyer et Electricité
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ moisNoms[parseInt(facture?.mois)] }} {{ facture?.annee }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ typeof facture?.contrat === 'object' ? facture?.contrat?.reference : facture?.contrat }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="getStatutBadge(Number(facture?.statut)).badgeClass">
                  {{ getStatutBadge(Number(facture.statut)).text }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a v-if="(Number(facture.statut) === 0 || Number(facture.statut) === 1 || Number(facture.statut) === 3)"
                        @click="openNewWindow(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Aperçu facture
                      </a>
                      <a v-if="(Number(facture.statut) === 2 || Number(facture.statut) === 4 || Number(facture.statut) === 5)"
                        @click="openNewWindow2(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Aperçu facture
                      </a>
                      
                    </li>
                    <li>
                      <a href="javascript:void(0);" @click="regenererEtImprimer(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-printer lh-1 me-8 position-relative top-1"></i>
                        Réimprimer (mis à jour)
                      </a>
                    </li>
                    <li v-if="(Number(facture.statut) === 0 || Number(facture.statut) === 1 || Number(facture.statut) === 3)">
                      <a @click="normaliser(facture)" type="button" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-send lh-1 me-8 position-relative top-1"></i>
                        Normalisée la facture
                      </a>
                    </li>
                    <li v-if="(Number(facture.statut) != 3 && Number(facture.statut) != 5 )">
                      <a href="javascript:void(0);" data-bs-target="#create-task" data-bs-toggle="modal"
                        @click="openModal(facture.id, facture.reference)" class="dropdown-item d-flex align-items-center">
                        <i class="flaticon-close lh-1 me-8 position-relative top-1"></i> Annuler facture
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    

      <div class="modal fade" id="create-task" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Voulez-vous annuler cette facture ?</h6>
              <button type="button" id="close-modal" class="btn-close" data-bs-dismiss="modal"
                aria-label="Close"></button>
            </div>
            <div class="modal-body px-4">
              <Form ref="depensesForm" @submit="addFactures" :validation-schema="facturesSchema">
                <div class="row gy-2">
                  <div class="col-md-4-3">
                    <label class="d-block fw-semibold mb-10">
                      Motif<span class="text-danger"></span>
                    </label>
                    <Field name="motifAnnuler" as="textarea" placeholder="Entrer le motif"
                      class="form-control shadow-none rounded-0 text-black" />
                    <ErrorMessage name="motifAnnuler" class="text-danger" />
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="submit" class="btn btn-primary">Annuler</button>
                  <button type="button" class="btn btn-danger" data-bs-dismiss="modal" aria-label="Close">
                    Fermer
                  </button>
                </div>
              </Form>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div> -->
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent2 :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
      <br>

      <div class="row">
      
        <div class="col-md-3">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Total factures {{ (_annee)? _annee : '' }}</h4>
            </div>
            <div class="card-body d-flex justify-content-center">
              <div class="fs-4"> {{ separateur(mt_total) }} </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Total TVA {{ (_annee)? _annee : '' }}</h4>
            </div>
            <div class="card-body d-flex justify-content-center">
              <div class="fs-4"> {{ separateur(mt_tva) }} </div>
            </div>
          </div>
        </div>

        <div class="col-md-3">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Total cautions {{ (_annee)? _annee : '' }}</h4>
            </div>
            <div class="card-body d-flex justify-content-center">
              <div class="fs-4"> {{ separateur(mt_caution) }} </div>
            </div>
          </div>
        </div>

        

      </div>

    </div>

  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Facture } from "@/models/Facture";
import ApiService from "@/services/ApiService";
import { suppression, error, getUrlApiForFiles, success, downloadExcel, separateur } from "@/utils/utils";
import PaginationComponent2 from '@/components/Utilities/Pagination2.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from 'yup';
import axios from 'axios';
export default defineComponent({
  name: "ListeFacture",
  components: {
    PaginationComponent2,
    Form,
    Multiselect,
    Field,
    ErrorMessage
  },
  setup() {
    onMounted(async () => {
      await getAllFactures();
      await getAllMarches();
      await getAllTypes();
      await getFactureTotal();
    });


    const marche = ref();
    const facturesSchema = Yup.object().shape({
      motifAnnuler: Yup.string().required("Le motif est obligatoire"),
    });
    const donne = ref({
      searchTerm: "",
      _contrat: null,
      _annee: null,
      _mois: null,
      _statut: null,
    });
    const mt_total = ref(0);
    const mt_caution = ref(0);
    const mt_tva = ref(0);
    const lesFactureAImprimer = ref<Array<number>>([]);
    const facturesForm = ref(null);
    const motCle = ref('');
    const facture = ref<Facture>();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const _statut = ref('');
    const _contrat = ref('');
    const contratOptions = ref();
    const typesOptions = ref([]);
    const _mois = ref('');
    const _annee = ref('');
    const contrats = ref();
    const factureForm = ref(null);
    const montant_facture = ref();
    const reference = ref();
    const contrat = ref();
    const factureii = ref();
    const _type = ref("");
    const factures = ref<Array<Facture>>([]); // Initialisez avec un tableau vide
    const checkedFactures = ref<Array<number>>([]); // Initialisez avec un tableau vide
    const openModal = (id: number) => {
      factureii.value = id;
    };
    const ajouterTableau = (event: Event, factureId: number) => {
      const input = event.target as HTMLInputElement;
      const isChecked = input.checked;

      console.log("Facture ID:", factureId);
      console.log("Checked:", isChecked);

      if (isChecked) {
        console.log("DEDANS")
        if (!checkedFactures.value.includes(factureId)) {
          console.log("DEDANS2")
          checkedFactures.value.push(factureId);
        }
        if (!lesFactureAImprimer.value.includes(factureId)) {
          console.log("DEDANS3")
          lesFactureAImprimer.value.push(factureId);
        }
      } else {
        checkedFactures.value = checkedFactures.value.filter(id => id !== factureId);
        lesFactureAImprimer.value = lesFactureAImprimer.value.filter(id => id !== factureId);
      }
    };

    const _annees = ref(
      Array.from({ length: 5 }, (_, i) => {
        const year = new Date().getFullYear() - 1 + i;
        return { value: year, label: year.toString() };
      })
    );
    const handlePaginate = async ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        // await rechercher()
        await getAllFactures(page_, limit_, motCle.value, _contrat.value, marche.value, _annee.value, _mois.value, _statut.value, _type.value);
      } catch (error) {
        //
      }
    };
    const getStatutBadge = (statut: number) => {
      switch (statut) {
        case 0:
          return {
            text: "Impayé",
            badgeClass: "badge bg-danger text-white",
          };
        case 1:
          return {
            text: "En attente",
            badgeClass: "badge bg-warning text-dark",
          };
        case 2:
          return {
            text: "Normalisée",
            badgeClass: "badge bg-info text-white",
          };
        case 3:
          return {
            text: "Annulée",
            badgeClass: "badge bg-secondary text-white",
          };
        case 4:
          return {
            text: "Normalisée_P ",
            badgeClass: "badge bg-success text-white",
          };
        case 5:
          return {
            text: "Avoir",
            badgeClass: "badge bg-dark text-white",
          };
        default:
          return {
            text: "",
            badgeClass: "badge bg-white text-danger",
          };
      }
    };

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";
    const contratSelect = async (value) => {
      const contrat = await axios.get(`/contrats/${value}`);
      const contratD = contrat.data.data;
      const contratData = contrat.data.data.contratElements;
      var som = parseFloat(contratD.loyer);
      contratData.forEach(element => {
        som += element.prix * element.quantite;
      });
      montant_facture.value = som;
      console.log(contrat.data.data, "contrat")
      console.log(value, "contrat")
    };

    const normaliser = async (value) => {
      try {
        Swal.fire({
          title: 'Êtes-vous sûr?',
          text: "Vous ne pourrez pas revenir en arrière!",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui, normaliser!',
          cancelButtonText: 'Annuler'
        }).then(async (result) => {
          if (result.isConfirmed) {
            const response = await axios.get(`/normalisationFacture/${value.id}`);
            let timerInterval;
            await Swal.fire({
              title: 'Normalisation en cours...',
              html: 'Cette fenêtre va se fermer dans <b></b> secondes.',
              timer: 3000,
              timerProgressBar: true,
              didOpen: () => {
                Swal.showLoading();
                const b = Swal.getHtmlContainer()?.querySelector('b');
                if (b) {
                  timerInterval = setInterval(() => {
                    const timeLeft = Swal.getTimerLeft();
                    if (timeLeft !== undefined) {
                      b.textContent = Math.ceil(timeLeft / 1000).toString();
                    }
                  }, 100);
                }
              },
              willClose: () => {
                clearInterval(timerInterval);
                Swal.hideLoading();
              }
            });
            if (response.data.code === 200) {
              success(response.data.message);
              await getAllFactures();
            }
          }
        });
      } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
          error(err.response.data.message);
        } else {
          error('An unknown error occurred');
        }
      }
    }

    const addFactures = async (values, { resetForm }) => {
      values["id"] = factureii.value;
      values["statut"] = true;
      ApiService.put("/Annulefactures/" + values.id, values)
        .then(({ data }) => {
          console.log('depense', data);
          if (data.code === 200) {
            success(data.message);
            resetForm();
            getAllFactures();
            triggerButtonClick("close-modal");
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    const fetchContrats = async (key) => {
      try {
        const response = await axios.get(`/contrats/recherche/${key}`);
        const contratsData = response.data.data;
        console.log(response)
        contratOptions.value = contratsData.map((contrat) => (
          {
            value: `${contrat.id}`,
            label: `${contrat.reference} - ${contrat?.codePlace}-[${contrat.nomMarchand}]`,
          }));
        if (contratOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return contratOptions.value;
      } catch (error) {
        //
      }
    }

    function triggerButtonClick(buttonId: string) {
      const button = document.getElementById(buttonId) as HTMLButtonElement;
      if (button) {
        button.click(); // Simule un clic
      } else {
        console.error(`Button with ID "${buttonId}" not found.`);
      }
    }
    function rechercher() {
      getAllFactures();
      getFactureTotal();
    }

    const getAllFactures = async (pagee = 1, limitt = 10, motClee = "", contratt = "", marchee = "", _anneee = "", _moiss = "", _statutt= "", _typee = "") => {
      const donnee = {
        searchTerm: searchTerm.value,
        motCle: (motClee) ? motClee : motCle.value,
        page: (pagee) ? pagee : page.value,
        limit: (limitt) ? limitt : limit.value,
        contrat: (contratt) ? contratt : _contrat.value,
        marche: (marchee) ? marchee : marche.value,
        annee: (_anneee) ? _anneee : _annee.value,
        mois: (_moiss) ? _moiss : _mois.value,
        statut: (_statutt) ? _statutt : _statut.value,
        type: (_typee) ? _typee : _type.value,
      }
      return await ApiService.post(`/all/factures`, donnee)
        .then(({ data }) => {
          factures.value = data.data.data;
          // mt_total.value = data.data.data.reduce((total, facture) => total + parseFloat(facture.montant_facture), 0); 
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log('dataNouveau', data.data);
          return data.data;
        })
        .catch(({ response }) => {
          console.log("Response ===> 0", response)
          error(response.data.message);
        });
    }

    const getFactureTotal = async (pagee = 1, limitt = -1, motClee = "", contratt = "", marchee = "", _anneee = "", _moiss = "", _statutt= "", _typee = "") => {
      const donnee = {
        searchTerm: searchTerm.value,
        motCle: (motClee) ? motClee : motCle.value,
        page: (pagee) ? pagee : page.value,
        limit: (limitt) ? limitt : limit.value,
        contrat: (contratt) ? contratt : _contrat.value,
        marche: (marchee) ? marchee : marche.value,
        annee: (_anneee) ? _anneee : _annee.value,
        mois: (_moiss) ? _moiss : _mois.value,
        statut: (_statutt) ? _statutt : _statut.value,
        type: (_typee) ? _typee : _type.value,
      }
      return await ApiService.post(`/all/factures/montant`, donnee)
        .then(({ data }) => {
          console.log("reccuperation du montant", data.data.totalMontant); //totalMontant
          mt_total.value = data.data.totalMontant;
          mt_caution.value = data.data.totalCaution;
          mt_tva.value = data.data.totalTva;
          // mt_total.value = data.data.data.reduce((total, facture) => total + parseFloat(facture.montant_facture), 0); 
        })
        .catch(({ response }) => {
          console.log("Response ===> 0", response)
          error(response.data.message);
        });
    }


    watch(_contrat, async (newValue) => {
      if (newValue !== undefined && newValue !== null && newValue !== '') {
        console.log("Contrat New ===> ", newValue)
        _contrat.value = newValue;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        _contrat.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(marche, async (newVal) => {
      if (newVal !== undefined && newVal !== null && newVal !== '') {
        marche.value = newVal;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        marche.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(_statut, async (newVal) => {
      if (newVal !== undefined && newVal !== null && newVal !== '') {
        _statut.value = newVal;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        _statut.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(_mois, async (newVal) => {
      if (newVal !== undefined && newVal !== null && newVal !== '') {
        _mois.value = newVal;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        _mois.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(_annee, async (newVal) => {
      if (newVal !== undefined && newVal !== null && newVal !== '') {
        _annee.value = newVal;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        _annee.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(motCle, async (newVal) => {
      if (newVal !== undefined && newVal !== null && newVal !== '') {
        motCle.value = newVal;
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }else{
        motCle.value = "";
        page.value = 1;
        limit.value = 10;
        await rechercher();
      }
    });
    watch(_type, async (newTerm, oldTerm) => {
      if (newTerm !== oldTerm && newTerm !== "") {
        page.value= 1;
        limit.value = 10;
        _type.value = newTerm;
        await rechercher();
      }
    });

    function moddifier(Editfactures: Facture) {
      facture.value = Editfactures;
    }
    const getMonthName = (monthNumber) => {
      const months = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];
      return months[monthNumber] || "Mois inconnu";
    };
    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");
      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };

    function openNewWindow(data: any, dossier = "Facture") {
       
        Swal.fire({
          title: 'Chargement...',
          html: 'Veuillez patienter pendant que le fichier est préparé.',
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          }
        });

        // Vérifier l'existence du fichier
        const fileUrl = getUrlApiForFiles(dossier, data.reference + ".pdf");
        // openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));

        const checkAndOpenFile = async () => {
          console.log("POSITION 2");
          const requestData = {
            dossier: dossier || "Facture",
            nomFichier: data.reference ? `${data.reference}.pdf` : null
          };
          await ApiService.post('/facture/verifyExistingFile', requestData)
            .then(response => {
              console.log('Response:', response);
              Swal.close(); // Fermer le loader
              if (response.data.code == 200) {
                // Le fichier existe, l'ouvrir
                openAndPrint(fileUrl);
              } else {
                console.log('Le fichier n\'existe pas, régénération nécessaire');
                // Le fichier n'existe pas, le régénérer
                regenererFIchier(data, fileUrl, dossier);
              }
            })
            .catch(error => {
              console.log('Erreur lors de la vérification du fichier:', error);
              Swal.close(); // Fermer le loader
              Swal.fire({
                title: 'Erreur',
                text: 'Impossible de vérifier la disponibilité du fichier.',
                icon: 'error',
                // confirmButtonText: 'OK'
              });
            });
        };
        // Vérifier l'existence du fichier
        checkAndOpenFile();

    }

    const regenererFIchier = async (data: any, fileUrl: any, dossier: any) => {
      try {
        console.log("on demmarre");
        // Mettre à jour le message de chargement
        Swal.update({
          title: 'Préparation de la facture...',
          html: `Le fichier est en cours de génération, veuillez patienter...`
        });
        console.log("nous sommes là pour la genération du fichier");

        // Appeler l'API pour régénérer le fichier
        const response = await ApiService.post('/regenererfichier', { facture: data });
        // console.log('Response de régénération:', response);
        if (response.data.code === 200) {
          // Attendre un peu pour que le fichier soit généré
          setTimeout(() => {
            const requestData = {
              dossier: dossier || "",
              nomFichier: data.reference ? `${data.reference}.pdf` : null
            };
            // Revérifier la disponibilité du fichier
            ApiService.post('/facture/verifyExistingFile', requestData)
              .then(response => {
                // Swal.close();
                if (response.data.code === 200) {
                  Swal.close();
                  // Le fichier a été généré avec succès
                  openAndPrint(fileUrl);
                } else {
                  // La régénération a échoué
                  Swal.fire({
                    title: 'Échec de génération',
                    text: 'Impossible de générer le fichier. Veuillez réessayer.',
                    icon: 'error',
                    confirmButtonText: 'OK'
                  });
                }
              })
              .catch(error => {
                Swal.close();
                Swal.fire({
                  title: 'Erreur',
                  text: 'Erreur lors de la vérification du fichier généré.',
                  icon: 'error',
                  confirmButtonText: 'OK'
                });
                // console.error('Erreur lors de la vérification:', error);
              });
            
          }, 5000); // Attendre 5 secondes
        }
      } catch (error) {
        Swal.close();
        Swal.fire({
          title: 'Erreur de génération',
          text: 'Une erreur est survenue lors de la génération du fichier.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        console.error('Erreur lors de la régénération:', error);
      }
    };

    function openNewWindowExcel(data: any, dossier = "Facture") {
      openAndPrint(getUrlApiForFiles(dossier, data.reference + ".xlsx"));
    }

    function openNewWindow2(data: any, dossier = "Facture_Normalisees") {

      Swal.fire({
        title: 'Chargement...',
        html: 'Veuillez patienter pendant que le fichier est préparé...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Vérifier l'existence du fichier
        const fileUrl = getUrlApiForFiles(dossier, data.reference + ".pdf");
        // openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));

        const checkAndOpenFile = async () => {
          const requestData = {
            dossier: dossier || "Facture_Normalisees",
            nomFichier: data.reference ? `${data.reference}.pdf` : null
          };
          await ApiService.post('/facture/verifyExistingFile', requestData)
            .then(response => {
              console.log('Response:', response);
              // Swal.close(); // Fermer le loader
              if (response.data.code == 200) {
                 Swal.close();
                // Le fichier existe, l'ouvrir
                openAndPrint(fileUrl);
              } else {

                console.log('Le fichier n\'existe pas, régénération nécessaire');
                // Le fichier n'existe pas, le régénérer
                regenererFIchier(data, fileUrl, dossier);
                
              }
            })
            .catch(error => {
              console.log('Erreur lors de la vérification du fichier:', error);
              Swal.close(); // Fermer le loader
              Swal.fire({
                title: 'Erreur',
                text: 'Impossible de vérifier la disponibilité du fichier.',
                icon: 'error',
                // confirmButtonText: 'OK'
              });
            });
        };
        // Vérifier l'existence du fichier
        checkAndOpenFile();

      // openAndPrint(getUrlApiForFiles(dossier, data.reference + ".pdf"));
    }

    const regenererEtImprimer = async (data: any) => {
      try {
        // je voudrais utiliser  Swal.fire pour afficher un message de chargement pendant la régénération du PDF, mais comme c'est une fonction asynchrone, je vais faire simple pour l'instant
        Swal.fire({
          title: "Régénération de la facture",
          text: "Veuillez patienter pendant que le document est régénéré...",
          allowOutsideClick: false,
          didOpen: () => {
            Swal.showLoading();
          },
        });

        let dossier = "Facture";
        if([2,4,5].includes(data.statut)){
          dossier = "Facture_Normalisees";
        }
        // console.log("Dossier pour régénération:", data);
        const fileUrl = getUrlApiForFiles(dossier, data.reference + ".pdf");
        regenererFIchier(data, fileUrl, dossier);

      } catch (err) {
        error("Erreur lors de la régénération du PDF");
      }
    };

    const deleteFacture = (id: number) => {
      ApiService.delete(`/factures/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });
      for (let i = 0; i < factures.value.length; i++) {
        if (factures.value[i].id === id) {
          factures.value.splice(i, 1);
        }
      }
    };

    const annulerFacture = (id: number, reference: string) => {
      Swal.fire({
        title: "Confirmation",
        text: `Voulez-vous vraiment annuler la facture ${reference} ?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Annuler",
        cancelButtonText: "Retour"
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.put(`/Annulefactures/${id}`, {})
            .then(({ data }) => {
              Swal.fire({
                title: "Annulé",
                text: "La facture a été annulée avec succès.",
                icon: "success",
                timer: 2000,
                showConfirmButton: false
              });
              getAllFactures();
            })
            .catch(({ response }) => {
              Swal.fire({
                title: "Erreur",
                text: response.data.message || "Une erreur est survenue.",
                icon: "error",
                confirmButtonText: "Ok"
              });
            });
        }
      });
    };

    const getAllContrats = async () => {
      try {
        const response = await ApiService.get('/all/contrats');
        const contratsData = response.data.data.data;
        console.log('Data', contratsData)
        contratOptions.value = contratsData.map((contrat) => ({
          value: contrat.id,
          label: contrat.reference,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }
    const marcheOptions = ref([]);

    const getAllMarches = async () => {
      try {
        const response = await ApiService.get('/all/marches');
        const marcheData = response.data.data.data;
        console.log('Data', marcheData)
        marcheOptions.value = marcheData.map((marche) => ({
          value: marche.id,
          label: marche.libelle,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }

    const moisNoms = [
      "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
      "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    function formatPeriode(periode: string): string {
      if (!periode) return "";
      const [year, month] = periode.split("-");
      return `${moisNoms[parseInt(month, 10) - 1]} ${year}`;
    }

    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    const valideEtape3 = ref(true);
    const valideEtape4 = ref(true);
    const toutImprimer = ref(false);


    const imprimer = async () => {
      const donnee = {
        searchTerm: searchTerm.value,
        motCle: motCle.value,
        page: page.value,
        limit: limit.value,
        marche: marche.value,
        contrat: _contrat.value,
        annee: _annee.value,
        mois: _mois.value,
        statut: _statut.value,
        tout: toutImprimer.value,
        laSelection: lesFactureAImprimer.value
      }
      try {
        const response = await axios.post(`imprimer/factures/selectionner`, donnee);
        if (response.status === 200) {
          console.log("response", response)
          openNewWindow({ reference: response.data.data }, "Fusion");
          valideEtape3.value = true;
          success(response.data.message);
        }

      } catch (err) {
        valideEtape3.value = false;
        console.log("ERREUR ==> ", err)
        error("Une erreur s'est produite lors de la génération du PV.");
      }
    }
    const getPoint = async () => {
      try {
        valideEtape3.value = false;
        const donne = {
          searchTerm: searchTerm.value,
          contrat: _contrat.value,
          marche: marche.value,
          annee: _annee.value,
          mois: _mois.value,
          statut: _statut.value,
          motCle: motCle.value,
        };
        const response = await axios.post("/generer/point/facture", donne);
        console.log("RESPONSE ==> ",)
        //await openNewWindowExcel({ reference: (response.data.data) }, "Excel");
        await openAndPrint(getUrlApiForFiles("Excel", response.data.data + ".xlsx"));
        await openNewWindow({ reference: response.data.data }, "Point_Facture");

        valideEtape3.value = true;
      } catch (err) {
        valideEtape3.value = false;
        console.log("ERREUR ==> ", err)
        error("Une erreur s'est produite lors de la génération du PV.");
      }
    };

    const toggleAllCheckboxes = (event: Event) => {
      const isChecked = (event.target as HTMLInputElement).checked;
      if (isChecked) {
        toutImprimer.value = true;
        // Coche tous les checkboxes et ajoute leurs valeurs à lesFactureAImprimer
        checkedFactures.value = factures.value.map((facture) => facture.id);
        lesFactureAImprimer.value = factures.value.map((facture) => facture.id); // Ajoute toutes les factures
      } else {
        toutImprimer.value = false;
        // Décoche tous les checkboxes et vide lesFactureAImprimer
        checkedFactures.value = [];
        lesFactureAImprimer.value = [];
      }
    };

    const getAllTypes = async () => {
      try {
        const response = await ApiService.get("/all/type");
        const typesData = response.data.data.data;
        console.log("Data", typesData);
        typesOptions.value = typesData.map((type) => ({
          value: type.id,
          label: type.libelle,
        }));
      } catch (error) {
        //error(response.data.message)
      }
    };

    watch(checkedFactures, () => {
      const allChecked = checkedFactures.value.length === factures.value.length;
      const mainCheckbox = document.getElementById("Tout sélectionner") as HTMLInputElement;
      if (mainCheckbox) {
        mainCheckbox.checked = allChecked;
      }
    });

    watch(lesFactureAImprimer, async (newValue) => {
      console.log("Les factures à imprimer:", newValue);
    });

    return {
      mt_total,
      mt_caution,
      mt_tva,
      marcheOptions,
      marche,
      imprimer,
      lesFactureAImprimer,
      valideEtape4,
      ajouterTableau,
      checkedFactures,
      valideEtape3,
      getPoint,
      factures,
      checkPermission,
      getAllFactures,
      deleteFacture,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      getStatutBadge,
      annulerFacture,
      moisNoms,
      _contrat,
      _statut,
      contratOptions,
      typesOptions,
      getMonthName,
      _annees,
      _annee,
      _mois,
      _type,
      fetchContrats,
      nooptions,
      noOptionsTextAbb,
      contratSelect,
      normaliser,
      openModal,
      openNewWindow2,
      openNewWindow,
      addFactures,
      facturesSchema,
      motCle,
      toggleAllCheckboxes,
      separateur,
      regenererEtImprimer
    };
  },
});
</script>